import { useCallback, useContext, useState } from "react";
import { createPortal } from "react-dom";
import { FiX } from "react-icons/fi";

import { Button } from "~/components/Button";
import { Modal } from "~/components/Modal";
import { deleteStudent } from "~/modules/students/services";

import { studentCardContext } from "../..";

type Props = {
	onSuccess: () => void;
};

export const DeleteStudentButton: React.FC<Props> = ({ onSuccess }) => {
	const { student } = useContext(studentCardContext);
	const [showModal, setShowModal] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);

	const handleToggleModal = useCallback(() => {
		setShowModal((state) => !state);
	}, []);

	const handleDeleteStudent = useCallback(() => {
		setLoading(true);
		deleteStudent(student.id).then((success) => {
			if (success) {
				onSuccess();
			}
			setLoading(false);
			setShowModal(false);
		});
	}, [student.id, onSuccess]);

	return (
		<>
			<Button color="error" onClick={handleToggleModal}>
				Apagar dados do aluno
			</Button>
			{createPortal(
				<Modal visible={showModal}>
					<div className="flex flex-col gap-4">
						<div className="flex items-center justify-between mb-4">
							<h1 className="text-xl font-semibold">Confirmação de exclusão</h1>
							<button
								type="button"
								className="p-2 rounded-full hover:bg-slate-50"
								onClick={handleToggleModal}
							>
								<FiX size={26} />
							</button>
						</div>

						<p className="text-base">
							Tem certeza que deseja apagar todos os dados deste aluno?{" "}
							<b>
								Todas as avaliações e todo o progresso relacionado a este aluno
								também serão permanentemente perdidos!
							</b>
						</p>

						<div className="flex gap-4 flex-wrap mt-2">
							<Button
								className="flex-1"
								color="error"
								disabled={loading}
								loading={loading}
								onClick={handleDeleteStudent}
							>
								Deletar aluno
							</Button>
							<Button
								className="flex-1"
								mode="outlined"
								onClick={handleToggleModal}
							>
								Cancelar
							</Button>
						</div>
					</div>
				</Modal>,
				document.getElementById("modals")!,
			)}
		</>
	);
};
